import Vue from 'vue'

const state = {
    family: {
        my: {
            headerData: [
                { index: 0, label: Vue.prototype.$t("code-lab/component/file-management/observable/headerOber.js_0"), rootIs: true, query: { path: '/', folderId: null, folderType: 'my' } },
            ]
        }
    },
    teacher: {
        my: {
            headerData: [
                { index: 0, label: Vue.prototype.$t("code-lab/component/file-management/observable/headerOber.js_1"), type: 'cloud', query: { path: '/', folderId: null, folderType: 'my' } },
                { index: 1, label: Vue.prototype.$t("code-lab/component/file-management/observable/headerOber.js_2"), rootIs: true, query: { path: '/', folderId: null, folderType: 'my' } }
            ]
        },
        shared: {
            headerData: [
                { index: 0, label: Vue.prototype.$t("code-lab/component/file-management/observable/headerOber.js_3"), type: 'cloud', query: { path: '/', folderId: null, folderType: 'my' } },
                { index: 1, label: Vue.prototype.$t("code-lab/component/file-management/observable/headerOber.js_4"), rootIs: true, query: { path: '/', folderId: null, folderType: 'shared' } }
            ]
        }
    }
}

export const store = Vue.observable(state)

export const mutations = {}
